import { AcornsIcon, Icon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'
import React from 'react'
import styled from 'styled-components'
import { style } from 'theme'

const Container = styled.div`
  width: 100%;
  margin-top: 30px;
  max-width: 450px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 0px 30px 30px;
    margin: 0 auto;
    background: ${style((theme) => theme.colors.white)};
  }
`

const Card = styled.div`
  width: 100%;
  background: ${style((theme) => theme.colors.purple)};
  background-size: 115% auto;
  padding: 20px;
  color: ${style((theme) => theme.colors.white)};
  border-radius: ${style((theme) => theme.borderRadius.large)};
  display: flex;
  flex-direction: row;
`

const StyledIcon = styled(AcornsIcon)`
  [fill] {
    fill: ${style((theme) => theme.colors.white)};
  }
  margin-right: 15px;
`

const TextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

const Title = styled.h1`
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  margin: 2px 0 5px;
`

const Body = styled.p`
  margin: 0 auto;
  font-size: 14px;
  line-height: 22px;
  width: 100%;
`

export const RebalanceNotification = () => {
  const { getRemoteString } = useRemoteStrings()
  return (
    <Container>
      <Card>
        <StyledIcon icon={Icon.ProductGrow} height={24} />
        <TextContainer>
          <Title>
            {getRemoteString({
              key: 'invest.portfolio.new_etf_card.unaligned.title',
            }) || 'Heads up!'}
          </Title>
          <Body>
            {getRemoteString({
              key: 'invest.portfolio.new_etf_card.unaligned.body',
            })}
          </Body>
        </TextContainer>
      </Card>
    </Container>
  )
}
